import { render, staticRenderFns } from "./ProductAttributesManager.vue?vue&type=template&id=c3ac95fe"
import script from "./ProductAttributesManager.vue?vue&type=script&lang=js"
export * from "./ProductAttributesManager.vue?vue&type=script&lang=js"
import style0 from "./ProductAttributesManager.vue?vue&type=style&index=0&id=c3ac95fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports